import type { ReactNode } from 'react';
import { Chip } from '@nextui-org/react';

export type StatusTone = 'default' | 'info' | 'success' | 'warning' | 'danger';

// "primary" es el color de la especie (rojo en cereza) y se confundiría con
// danger, así que "en curso" va en azul, igual que En tránsito en Despachos.
const INFO_CLASSES = {
  base: 'bg-blue-100 dark:bg-blue-500/20',
  content: 'text-blue-700 dark:text-blue-300',
};

// Chip de estado: siempre flat y chico. El tono dice el tipo de estado:
// success = listo, warning = pendiente, danger = vencido o error,
// info = en curso, default = neutro o inactivo. Ver design.md › Estados.
const StatusChip = ({
  tone = 'default',
  children,
}: {
  tone?: StatusTone;
  children: ReactNode;
}) =>
  tone === 'info' ? (
    <Chip size='sm' variant='flat' classNames={INFO_CLASSES}>
      {children}
    </Chip>
  ) : (
    <Chip size='sm' variant='flat' color={tone}>
      {children}
    </Chip>
  );

export default StatusChip;
